export default "__VITE_ASSET__YQE_Lc4X__"